var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"iframe-wrap"},[(_vm.iframeSrc)?_c('iframe',{ref:"frame",staticClass:"embed",attrs:{"src":_vm.iframeSrc,"frameborder":"0","title":"Gerador de Link Cielo"},on:{"load":_vm.onLoad}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }